import { getContent, putContent, searchAll, searchContent } from './confluence';
import { createAnswerPutPayload } from '../payloads';
import { ANSWER_TYPE } from '../constants/custom-content';
import { LIMIT_ANSWERS } from './limits';
import { buildRequest } from './question-list';

export const ANSWER_EXPANSIONS =
	'' +
	'container,' +
	'metadata.properties.atl_cq_votes,' +
	'metadata.properties.atl_cq_accepted_answer,' +
	'operations,' +
	'body.view,' +
	'body.atlas_doc_format,' +
	'history,' +
	'version,' +
	'children.comment.body.view,' +
	'children.comment.body.atlas_doc_format,' +
	'children.comment.operations,' +
	'children.comment.history,' +
	'children.comment.version';

export const putAnswer = (body, content, parentId, spaceKey) =>
	putContent(
		content.id,
		createAnswerPutPayload(content.version.number + 1, spaceKey, parentId, content.title, body),
	);

export const getAnswers = (questionId, pageNumber = 0, cursor) => {
	const cql = `type='${ANSWER_TYPE}' and container=${questionId} order by atl_cq_votes_total desc, created asc`;

	return searchContent(
		buildRequest({
			expand: ANSWER_EXPANSIONS,
			cql,
			pageNumber,
			limit: LIMIT_ANSWERS,
			cursor,
		}),
	);
};

export const getAnswer = (id) => getContent(id, { expand: ANSWER_EXPANSIONS });

export const getAnswerCount = (questionId) => {
	const cql = `type='${ANSWER_TYPE}' and container=${questionId}`;
	return searchAll({
		cql,
		limit: 0,
	});
};
